import React from 'react'
import EeveeCallOut from './ev-callout'
import classNames from 'classnames'
import { Icon } from '../../atoms'
import Image from '../imgix-img'
import { connect } from 'react-redux'
import { query } from '../../redux/app-selectors'

interface CallOutProps {
  variant: string
  text: string
  bold: boolean
  title: string
}

const CallOut: React.FC<CallOutProps> = (props) => {
  const { variant, text, bold, title } = props

  if (variant === 'platinum' || variant === 'platinum-warning' || variant === 'smaller') {
    return (
      <div className='CallOut'>
        {variant === 'platinum-warning' && (
          <div className='CallOut__icon'>
            <Icon glyph={'info-blob'} size={24} desktopSize={32} color={'black'} />
          </div>
        )}
        <div
          className={classNames('CallOut__text', {
            'CallOut__text--bold': bold,
            'CallOut__text--smaller': variant === 'smaller',
          })}
        >
          {text}
        </div>
      </div>
    )
  } else if (variant === 'fscs') {
    return (
      <div className='CallOut_fscs'>
        <div className='CallOut_fscs__icon'>
          <Image
            src='https://img.money.co.uk/t014ej9w3ur1/4DqU14fOaE16S09KLWeFcq/4ad81b80d8dde3b5c7ff5e62eee64d3d/fscs_logo_2x.png'
            alt='fscs-logo'
            width={100}
            height={66}
            critical={false}
          />
        </div>
        <div className='CallOut_fscs__text'>
          <div className='CallOut_fscs__text__title'>{text}</div>
          <div>{title}</div>
        </div>
      </div>
    )
  } else if (variant === 'cass') {
    return (
      <div className='CallOut_fscs'>
        <div className='CallOut_fscs__icon'>
          <Image
            src='https://img.money.co.uk/t014ej9w3ur1/7KMvvHFCnElHHH9llkBvuV/6f6eeba2be9bba953bfef02690b093d6/cass_logo.jpg'
            alt='cass-logo'
            width={100}
            height={66}
            critical={false}
          />
        </div>
        <div className='CallOut_fscs__text'>
          <div className='CallOut_fscs__text__title'>{text}</div>
          <div>{title}</div>
        </div>
      </div>
    )
  } else if (variant === 'scam-warning') {
    const hasUtm = !!Object.keys(props.query).find((p) => p.includes('utm'))
    return (
      <>
        {!hasUtm && (
          <div className='CallOut'>
            <div className='CallOut__icon'>
              <Icon glyph={'info-blob'} size={24} desktopSize={32} color={'black'} />
            </div>
            <div
              className={classNames('CallOut__text', {
                'CallOut__text--bold': bold,
              })}
            >
              {text}
            </div>
          </div>
        )}
      </>
    )
  } else {
    return <EeveeCallOut {...props} />
  }
}

export default connect((state, props) => {
  return {
    ...props,
    query: query(state),
  }
})(CallOut)
